import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, message, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { showAuthLoader, userSignIn, userSignInSuccess } from "../appRedux/actions/Auth";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "../components/CircularProgress/index";
import { min } from "lodash";
import { constrainedMemory } from "process";
import { postJson } from "../util/V3Api";
import { type } from "os";
import { SIGNIN_USER_SUCCESS } from "../constants/ActionTypes";
const SignIn = (props) => {
 const[stage,setStage]=useState(1);
 const[mobile,setMobile]=useState(1);
 const[serverErr,setServerErr]=useState('');
  const dispatch = useDispatch();
  const {
    loader,
    token,
    alertMessage,
    showMessage,
  } = useSelector(({ auth }) => {
    return auth;
  });

  useEffect(() => {
    if (token != null) {
      props.history.push("/samplePage");
    }
  });

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    
    //dispatch(showAuthLoader());
    /* dispatch(userSignIn(values)); */
    //console.log(values)
    //stage==1&&postJson('/login/verify',values.mobile).then(()=>{setMobile(values.mobile);setStage(2)})
    stage==1&&postJson('login/verify',values.mobile).then(()=>{setMobile(values.mobile);setStage(2)}).catch((e)=>{setServerErr(e?.errors?.[0]?.message)})
    stage==2&&postJson('login',{phoneNumber:mobile,token:values.code}).then((d)=>{localStorage.setItem("token", d.data.accessToken);localStorage.setItem("reToken", d.data.refreshToken);localStorage.setItem("user_id", mobile);dispatch(userSignInSuccess({at:d.data.accessToken,rt:d.data.refreshToken}))}).catch((e)=>{setServerErr(e?.errors?.[0]?.message)})
  };
  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img
                src={require("../../src/assets/images/sea.jpg").default}
                alt="Neature"
              />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signIn" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img alt="example" src="/assets/images/logo.png" />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              {stage==1&&<Form.Item
                initialValue=""
                rules={[{ required: true, message: " شماره موبایل را وارد کنید"},{max:11, message: " شماره موبایل را وارد کنید"},{min:11, message: " شماره موبایل را وارد کنید"}]}
                name="mobile"
                id="mobile"
              >
                <Input type='tel' placeholder="شماره موبایل" name="mobile" id="mobile"/>
              </Form.Item>}
            {stage==2 &&  <Form.Item
                initialValue=""
                rules={[{ required: true, message: " توکن را وارد کنید"},{max:4, message: " توکن را وارد کنید"},{min:4, message: " توکن را وارد کنید"}]}
                name="code"
                
              >
                <Input type='tel' placeholder="کد دریافتی" name="code" />
              </Form.Item>}
              {serverErr&&<h5 className="gx-text-red">{serverErr}</h5>}
             {/*  <Form.Item
                initialValue=""
                rules={[{ required: true, message: "نام کاربری را وارد کنید" }]}
                name="email"
              >
                <Input placeholder="نام کاربری" />
              </Form.Item>
              <Form.Item
                initialValue=""
                rules={[{ required: true, message: "کلمه عبور را وارد کنید!" }]}
                name="password"
              >
                <Input type="password" placeholder="کلمه عبور" />
              </Form.Item> */}
             {/*  <Form.Item name="remember" valuePropName="checked">
                <Checkbox>مرا به خاطر بسپار</Checkbox>
              </Form.Item> */}
              <Form.Item>
                <Button type="primary" className="gx-mb-0" htmlType="submit">
                 {stage==1&&'دریافت کد'|| stage==2&& <IntlMessages id="app.userAuth.signIn" />}
                </Button>
               {stage==2&& <Button type="ghost" className="gx-mb-0" onClick={()=>{setStage(1);setServerErr('')}}>
                  بازگشت
                </Button>}
               {/*  <Button type="danger" ghost className="gx-mb-0"  onClick={(e)=>{props.history.push("/forgot")}}>یادآوری کلمه عبور</Button>
                <Button ghost type="danger" ghost  className="gx-mb-0"  onClick={(e)=>{props.history.push("/signup")}}>
                  <IntlMessages id="app.userAuth.signUp" />
                </Button> */}
              </Form.Item>
            </Form>
          </div>

          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default SignIn;
